// THE FILE SHELLVERSIONINFO.TS IS AUTOMATICALLY GENERATED DURING BUILD PROCESS
// MANUAL CHANGES TO THIS FILE WILL BE OVERWRITTEN !!!

export const SHELL_VERSION_INFO = {
VERSION : '1.27.0',
BUILD_TS: '2026-04-20T10:43:39.860Z'
};

